<template>
  <div>
    <a-modal
        :width="330"
        title="分享好友"
        :visible="isShowShare"

    >
      <div>
        <div class="text-center w-200 h-200 mx-auto">
          <img class="block w-200 h-200 mx-auto" :src="qrcode" alt="">
        </div>
        <div class="text-center text-gray-501 pt-20">微信扫码分享给好友吧</div>
      </div>
    </a-modal>

    <!-- 图文s-->
    <div class="bg-white pb-50" v-if="type==1">
      <div class="container mx-auto ">
        <div class="py-20">
          <a-breadcrumb separator=">">
            <a-breadcrumb-item><router-link  class="cursor-pointer" tag="span" to="/">首页</router-link> </a-breadcrumb-item>
            <a-breadcrumb-item>{{detailData.name}}</a-breadcrumb-item>
          </a-breadcrumb>
        </div>

        <div class="flex relative">
          <div class="ss-lesson-cover-img flex-none">
            <img :src="detailData.image" class="object-cover" alt="">
          </div>

          <div class="pl-30 pr-60">
            <div class="text-30 text-gray-900 mb-20">{{ detailData.name }}</div>
            <div class="text-12 text-gray-501 mb-15">{{ detailData.exname }}</div>
            <div class="text-12 text-gray-501 mb-15"><span
                v-if="is_course==1"><span>{{ detailData.zhang }}章{{ detailData.jie }}节  </span> <span
                v-if="detailData.price>0">{{ detailData.sales_num }}人已购买</span></span></div>
          </div>

          <!-- <div class="absolute right-0 top-0 center cursor-pointer" @click="openShare" v-if="stateIsBind==1">
            <div class="flex w-32 h-32 rounded-full ss-wx-icon mx-auto"><span class="iconfont icon-wx m-auto text-white text-16"></span></div>
            <div class="text-12 text-gray-501 pt-5">分享好友</div>
          </div> -->

        </div>

      </div>
    </div>
    <!-- 图文e-->

    <!-- 视频s-->
    <div class="ss-video-box pb-40" v-if="type==2">
      <div class="container mx-auto ">
        <div class="py-20">
          <a-breadcrumb separator=">" class="">
            <a-breadcrumb-item><router-link  class="cursor-pointer" tag="span" to="/">首页</router-link> </a-breadcrumb-item>
            <a-breadcrumb-item>{{detailData.name}}</a-breadcrumb-item>
          </a-breadcrumb>
        </div>

        <div class="relative">
          <div class="text-30 text-white mb-20 pr-100">{{ detailData.name }}</div>
          <div class="text-12 text-white mb-15 pr-100">{{ detailData.exname }}</div>

          <!-- <div class="absolute right-0 top-0 center cursor-pointer" @click="openShare" v-if="stateIsBind==1">
            <div class="flex w-32 h-32 rounded-full ss-wx-icon mx-auto"><span class="iconfont icon-wx m-auto text-white text-16"></span></div>
            <div class="text-12 text-white pt-5">分享好友</div>
          </div> -->
        </div>

        <div class="ss-video-inner">
          <m-video ref="video" @end="end" :src="is_course==0? detailData.video :sub_data.video"
                   :poster="is_course==0? detailData.video_image :sub_data.video"></m-video>
        </div>

      </div>
    </div>
    <!-- 视频e-->


    <!-- 语音s-->
    <div class="bg-white pb-50" v-if="type==3">
      <div class="container mx-auto ">
        <div class="py-20">
          <a-breadcrumb separator=">">
            <a-breadcrumb-item><router-link  class="cursor-pointer" tag="span" to="/">首页</router-link> </a-breadcrumb-item>
            <a-breadcrumb-item>{{detailData.name}}</a-breadcrumb-item>
          </a-breadcrumb>
        </div>

        <div class="flex relative">
          <div class="ss-lesson-cover-img flex-none">
            <img :src="detailData.image" class="object-cover" alt="">
          </div>
          <div class="pl-30 pr-60">
            <div class="text-30 text-gray-900 mb-20">{{ detailData.name }}</div>
            <div class="text-12 text-gray-501 mb-15">{{ detailData.exname }}</div>
            <div class="text-12 text-gray-501 mb-15"><span
                v-if="is_course==1"><span>{{ detailData.zhang }}章{{ detailData.jie }}节  </span> <span
                v-if="detailData.price>0">{{ detailData.sales_num }}人已购买</span></span></div>
            <div class=" mt-25">
              <m-audio ref="audio" @audioEnd="audioEnd" :src="is_course==0? detailData.audio :sub_data.audio"></m-audio>
            </div>
          </div>

          <!-- <div class="absolute right-0 top-0 center cursor-pointer" @click="openShare"  v-if="stateIsBind==1">
            <div class="flex w-32 h-32 rounded-full ss-wx-icon mx-auto"><span class="iconfont icon-wx m-auto text-white text-16"></span></div>
            <div class="text-12 text-gray-501 pt-5">分享好友</div>
          </div> -->

        </div>

      </div>
    </div>
    <!-- 语音e-->

    <div class="mt-40 mb-100">
      <div class="container mx-auto">
        <div class="flex justify-between">
          <div class="ss-lesson-cont-l bg-white px-30 py-20">

            <div v-if="is_course==1">
              <div v-html="sub_data&&sub_data.content"></div>
            </div>
            <div v-else>
              <div v-html="detailData&&detailData.content"></div>
            </div>
          </div>

          <!-- <a-affix :offset-top="top" ref="affix_container"> -->
          <div ref="affixcontainer" :class="activeClass">
            <div class="rightSide">
              <div class="ss-lesson-cont-r self-start">
                <div v-if="is_course==1" class="bg-white  px-30 pt-20 pb-30 ">
                  <div class="text-18 text-gray-900 mb-20 ss-lesson-cont-r-teacher pl-15">课程目录</div>
                  <div class="">
                    <a-collapse :bordered="false" :default-active-key="index_1+''">
                      <a-collapse-panel :key="o_index+''" :header="o_item.section_name"
                                        v-for="(o_item, o_index) in detailData.sections" :style="customStyle">
                        <ul>
                          <li v-for="(t_item, t_index) in o_item.sub_section"
                              class="text-14 text-gray-900 py-5 block cursor-pointer" @click="subClick(t_item)"
                              :key="t_index">
                            <div class="ss-content-item ss-ellipsis" :class="[t_item.id==sub_data.id?'active':'']">
                              {{ t_item.name }}
                            </div>
                          </li>
                        </ul>
                      </a-collapse-panel>
                    </a-collapse>
                  </div>
                </div>

                <!-- <div v-if="is_course==0" class="bg-white  px-30 pt-20 pb-30 ">
                  <div class="text-18 text-gray-900 mb-20 ss-lesson-cont-r-teacher pl-15">授课老师</div>
                  <div class="flex py-10" v-for="(item, index) in detailData.teachers_info" :key="index">
                    <div class="w-72 h-72 rounded-full flex-none">
                      <img class="ss-lesson-cont-r-teacher-img rounded-full" :src="item.avatarUrl || mr_tx" alt="">
                    </div>
                    <div class="ml-15">
                      <div class="text-16 text-gray-900 pb-10">{{item.name}}</div>
                      <div class="text-12 text-gray-501">{{item.desc}}</div>
                    </div>
                  </div>
                </div> -->

                <div class="bg-white  px-30 pt-20 pb-30 ">
                  <div class="text-18 text-gray-900 mb-20 ss-lesson-cont-r-teacher pl-15">相关课程</div>
                  <div class=" py-10 cursor-pointer hover:text-blue-501"
                       v-for="(item, index) in (detailData&&detailData.about_content)" :key="index">
                    <router-link :to="'/lesson/lessonList?id='+item.id">
                      <div class="flex">
                        <div class="w-120 h-80 flex-none">
                          <img class="w-120 h-80 object-cover" :src="item.image" alt="">
                        </div>
                        <div class="ml-15">
                          <div class="text-14 text-gray-900 ss-ellipsis2 ">{{ item.name }}</div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>

              </div>
            </div>
            <!-- </a-affix> -->
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import mVideo from '@/components/mVideo'
import mAudio from '@/components/mAudio'

export default {
  components: {
    mVideo,
    mAudio
  },
  data() {
    return {
      training_plan_id: '',//个人中心培训带过来的培训id页面跳转过来
      time: 1,//定时器一分钟请求一次接口
      timer: null,//视频播放的定时器
      customStyle: 'border: 0;',
      top: 90, //
      detailData: null, // 详情数据
      type: 0, // 课程类型 1： 图文 2：视频 3：语音
      sub_data: null, // 详情某个数据
      index_1: 0, // 第一个索引
      index_2: 0, // 第二个索引
      id: 0, //一级级id
      content_id: 0, // 二级id (有章节课程才有)
      is_course: 0, // 0 单课程 1 章节课程
      isShowShare: false, // 是否打开分享弹框
      qrcode: '', // 小程序码
      activeClass: '',
      mr_tx: 'https://qxystatic.qingxiaoyun.com/qxy/20200807/5f2d25ab58753.png',// 默认头像
      studyTime:null,//学习时长

    }
  },
  created() {
    this.id = this.$route.query.id
    this.training_plan_id = this.$route.query.training_plan_id?this.$route.query.training_plan_id:''
    this.getLessonDetail()
    // 记录页面停留时间接口
    this.recordPageTime()
     // 一分钟就提交一次该接口，记录学习时长
    this.studyTime = setInterval(() => {
      this.recordStudyTime();
    }, 60000);
  },
  destroyed() {
    // 离开页面清除定时器
    clearInterval(this.timer)
    this.timer = null
    clearInterval(this.studyTime)
    this.studyTime=null

  },
  methods: {
    // 获取课程详情
    async getLessonDetail() {
      const {data: res} = await this.$http.get('index.php/internal/lore_content_api/content', {id: this.id})
      console.log(res, 'ccc')
      this.detailData = res
      this.type = res.type
      this.is_course = res.is_course

      //   const {id, content_id} = app.query;
      // const res_1 = await app.$axios.$get('gw_pcschool/content', {params: {id}}); // 获取详情数据
      // let is_course = res_1.data.is_course // 0 : 单课程  1 ： 章节课程

      let index_1 = 0;
      let index_2 = 0;
      // d = res_1.data
      // s = app.store.state.seo

      if (this.is_course == 1) {  //  1 ： 章节课程
        try {
          res.sections.forEach((o_item, o_index) => {
            o_item.sub_section.forEach((t_item, t_index) => {
              if (t_item.id == this.$route.query.content_id) {
                index_1 = o_index;
                index_2 = t_index;
                throw new Error('跳出循环');
              }
            })
          });
        } catch (res) {
          console.log(res)
        }
        this.sub_data = res.sections[index_1].sub_section[index_2];
      }


      // 如果是图文一进来就完成
      if (this.type == 1) {
        console.log(111111111111111)
        this.lessonComplete()
      }

    },
    // 进入该页面就执行，记录在该页面停留时间,60s执行一次，time传1分钟
    recordPageTime() {
      // 开启定时器
      this.timer = setInterval(async () => {
        const res = await this.$http.get('index.php/user/internal/study_time', {training_plan_id: this.training_plan_id, time: 1})
        console.log(res, '开始')
      }, 60000)
    },


    // 监控视频结束
    end() {
      // 如果是视频课程
      if (this.type == 2) {
        this.lessonComplete()
      }
    },
    // 监控音频播放结束
    audioEnd() {
      // 如果是音频课程
      if (this.type == 3) {
        this.lessonComplete()
      }
    },
    // 课程完成记录接口
    async lessonComplete() {
      await this.$http.get('index.php/user/internal/complete', {
        content_id: this.id,
        ext_content_id: '',
        training_plan_id: this.training_plan_id
      })
    },
    //记录课程的学习时长,1分钟调用一次
    recordStudyTime() {
    this.$http.get(
      'index.php/user/internal/studyTime',
      { content_id: this.id, ext_content_id:'',time: 1 } ,
     
    );
  }

  },
  // subClick(item) {
  //     this.sub_data = item;
  //     switch (this.type) {
  //       case 2: // 视频
  //         setTimeout(()=>{
  //           (this.$refs.video)._initVideoPlaye()
  //         }, 17);
  //         break;
  //       case 3: // 语音
  //         setTimeout(()=>{
  //           (this.$refs.audio)._initAudio()
  //         }, 17);
  //         break;
  //     }
  //   }
}
// import {Component, Vue} from 'vue-property-decorator';
// import {State} from "vuex-class";
// var d:any = {}
// var s:any = {}

// @Component({
//   async asyncData (app: any){
//     const {id, content_id} = app.query;
//     const res_1 = await app.$axios.$get('gw_pcschool/content', {params: {id}}); // 获取详情数据
//     let is_course = res_1.data.is_course // 0 : 单课程  1 ： 章节课程
//     let sub_data = {};
//     let index_1 = 0;
//     let index_2 = 0;
//     d = res_1.data
//     s = app.store.state.seo

//     if(is_course == 1) {  //  1 ： 章节课程
//       try {
//         res_1.data.sections.forEach((o_item:any, o_index:number)=>{
//           o_item.sub_section.forEach((t_item:any, t_index:number)=>{
//             if (t_item.id == content_id) {
//               index_1 = o_index;
//               index_2 = t_index;
//               throw new Error('跳出循环');
//             }
//           })
//         });
//       } catch (res) {
//       }
//       sub_data =  res_1.data.sections[index_1].sub_section[index_2];
//     }

//     if (res_1.code === 200) {
//       return {
//         detailData: res_1.data,
//         type: res_1.data.type,
//         sub_data,
//         index_1,
//         index_2,
//         id,
//         content_id,
//         is_course
//       }
//     } else if (res_1== 202) { //  该课程没有买
//       app.redirect('/lesson/lessonList?id='+id)
//     }
//   },

//   head() {
//     return {
//       title:  d.name + '-' + s.seo_title ,
//       meta: [
//         {
//           name: 'keywords',
//           content: '课程'
//         },
//         {
//           name: 'description',
//           content: d.exname
//         }
//       ]
//     }
//   }
// })

// export default class lessonDetail extends Vue {

//   @State('isBind') stateIsBind: any; //是否有公众号或者二维码
//   $axios: any;

//   mounted() {
//     // 监听滚动条距离底部的距离
//     window.addEventListener('scroll', this.scrollBottom)

//     this.learn_record() // 记录学习记录
//   if(this.stateIsBind==1){
// 	 this.get_qrcode() // 获取二维码
//   }

//   }
//    scrollBottom() {
//       // 变量scrollTop为当前页面的滚动条纵坐标位置
//       let scrollTop =
//         document.documentElement.scrollTop || document.body.scrollTop;
//       // 变量 windowHeight 是可视区的高度
//       let windowHeight =
//         document.documentElement.clientHeight || document.body.clientHeight;
//       // 变量 scrollHeight 是滚动条的总高度
//       let scrollHeight =
//         document.documentElement.scrollHeight || document.body.scrollHeight;

//         console.log('滚动条的总高度:',scrollHeight)
//         console.log('滚动条纵坐标位置:',scrollTop)
//         console.log(scrollHeight-327-windowHeight)
// 	// 到底的条件
//       if (scrollTop>=400&&scrollTop<scrollHeight-100-windowHeight){
//          this.activeClass="fixedContainer"
//       }else
//       {     // scrollTop + windowHeight == scrollHeight
//             //到底后要进行的操作
//             // this.$refs.affix_container
//             console.log(this.$refs.affixcontainer)
//             this.activeClass=''
//       }
//     }

//   subClick(item: any) {
//     this.sub_data = item;
//     switch (this.type) {
//       case 2: // 视频
//         setTimeout(()=>{
//           (this.$refs.video as any)._initVideoPlaye()
//         }, 17);
//         break;
//       case 3: // 语音
//         setTimeout(()=>{
//           (this.$refs.audio as any)._initAudio()
//         }, 17);
//         break;
//     }
//   }

//   async get_qrcode(){ // 获取小程序码
//     var res_1 = await this.$axios.$post('gw_pcschool/qrcode', {
//       path: 'pages/lore/courseContent/courseContent',
//       params: {id: this.id}
//     });
//     this.qrcode = res_1.data.qrcode;
//   }

//   learn_record(){ // 学习记录
//     this.$axios.$post('gw_pcschool/learn_record', {content_id: this.id, ext_content_id:this.content_id || 0, type: 0});
//   }

//   handleCancel() { // 点击了取消
//     this.closeShare()
//   }

//   closeShare() { // 关闭
//     this.isShowShare = false
//   }

//   openShare() { // 关闭
//     this.isShowShare = true
//   }

// }


</script>


<style scoped>
.ss-lesson-cover-img, .ss-lesson-cover-img img {
  width: 450px;
  height: 280px;
  background: #eee;
}

.ss-lesson-cont-l {
  width: 890px;
}

.ss-lesson-cont-r {
  width: 290px;
}

.ss-lesson-cont-r-teacher {
  border-left: 4px solid #5173f5
}

.ss-wx-icon {
  background: #26bc65;
  box-shadow: 0 5px 8px 0 rgba(38, 188, 101, 0.3);
}

>>> .ant-collapse-borderless {
  background: none !important;
}

>>> .ant-modal-footer {
  display: none;
}

.ss-video-box {
  background: #494b57
}

.ss-video-box >>> .ant-breadcrumb-separator {
  color: #fff;
}

.ss-video-box >>> .ant-breadcrumb > span:last-child {
  color: #fff;
}

.ss-video-box >>> .ant-breadcrumb {
  color: #fff;
}

.ss-video-inner {
  width: 960px;
  height: 540px;
  background: #000;
}

.ss-content-item.active {
  color: #5173f5
}

.ss-lesson-cont-r-teacher-img {
  width: 72px;
  height: 72px;
}

>>> .ant-collapse-header {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fixedContainer {
  left: 66%;
  top: 90px;
  position: fixed;
}
</style>
